import Router from "./router/router";
import "primereact/resources/themes/lara-light-indigo/theme.css"; // theme
import "primereact/resources/primereact.css"; // core css
import "primeicons/primeicons.css"; // icons
import "primeflex/primeflex.css";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CONFIGURATION_PREPEND,
  FACULTY_PREPEND,
  FRESHMAN_PREPEND,
  FRESHMAN_PROCESS_APPROVAL_PREPEND,
  ROUTER_URL,
  STAFF_PREPEND,
  STUDENT_PREPEND,
} from "./constants/routerUrl";
import Profile from "./common-components/profile/profile";
import Header from "./common-components/header";
import AdminTabs from "./common-components/adminTabs";
import { getCurrentUserData } from "./action/user/userProfileActionCreator";
import AdminUserSubMenu from "./common-components/menu/sub-menu/adminUserSubMenu";
import AdminConfigurationSubMenu from "./common-components/menu/sub-menu/adminConfigurationSubMenu";
import { UserRole } from "./constants/RoleEnum";
import LoaderSpinner from "./common-components/loader";
import FreshmanSubMenu from "./common-components/menu/sub-menu/freshmanSubMenu";
import { getAiAgentKey, getPreviousChatMessage } from "./action/ai/aiConfigurationActionCreator";
import { limit } from "./constants/pageBlocks";

function App(props: any) {
  const { currentRole, getUser, getAIPreviousChatMessage, fetchAiAgentKey } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState<boolean>(false);
  const location = useLocation();
  const freshmanApprovalPath = location.pathname.startsWith(FRESHMAN_PROCESS_APPROVAL_PREPEND);
  const [token] = useState<string | null>(localStorage.getItem("token"))
  const { pathname } = useLocation();
  
  useEffect(() => {
    if (!(token)) {
      navigate(ROUTER_URL.LOGIN);
    }
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith(FRESHMAN_PROCESS_APPROVAL_PREPEND)) {
      const searchParams = new URLSearchParams(location.search);
      const freshmanToken = searchParams.get("token");
      navigate(location.pathname);
    }
  }, [])


  useEffect(() => {
    const getUserData = async () => {
      setLoader(true);
      try {
        await getUser();
        getAIPreviousChatMessage(limit.five);
      } finally {
        setLoader(false);
      }
    };
    token && getUserData();
  }, [token]);

  useEffect(() => {
    if (currentRole) {
      fetchAiAgentKey();
    }
  }, [currentRole]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const renderSubMenu = () => {
    const basePath = location.pathname;

    if (basePath.startsWith(CONFIGURATION_PREPEND)) {
      return <AdminConfigurationSubMenu />;
    }
    if (basePath.startsWith(FRESHMAN_PREPEND)) {
      return <FreshmanSubMenu />;
    }
    if (
      basePath.startsWith(STAFF_PREPEND) ||
      basePath.startsWith(STUDENT_PREPEND) ||
      basePath.startsWith(FACULTY_PREPEND)
    ) {
      return <AdminUserSubMenu />;
    }
    return <></>;
  };

  return (
    <>
      {loader ? (
        <LoaderSpinner />
      ) : (
        <div className="wrap">
          <main>
            {(currentRole && !freshmanApprovalPath) && <Profile />}
            <section id="content">
              {(currentRole && !freshmanApprovalPath) && <Header />}
              <div className="admin-main">
                {(currentRole === UserRole.SuperAdmin ||
                  currentRole === UserRole.CollegeAdmin ||
                  currentRole === UserRole.DepartmentAdmin) && <AdminTabs />}
                {(currentRole && !freshmanApprovalPath) && renderSubMenu()}
                {(currentRole ||
                  location.pathname === ROUTER_URL.LOGIN ||
                  freshmanApprovalPath) && <Router />}
              </div>
            </section>
          </main>
        </div>
      )}
    </>

  );
}

const mapDispatchToProps = {
  getUser: () => getCurrentUserData(),
  getAIPreviousChatMessage: (limit: number) => getPreviousChatMessage(limit),
  fetchAiAgentKey: () => getAiAgentKey(),
};

function mapStateToProps(state: any) {
  return {
    currentRole: state.userDetails.userProfileData?.currentRole,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
